/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import CopyButton from "../../../../CopyButton/CopyButton";
import { useStyles } from "../../../styles";

interface IDetailsCardItemTextProps {
  textToRender: string | number | null | undefined;
  copiedValue?: string;
  hasCopyButton?: boolean;
  customStyle?: {};
  titleInlineAddition?: string | number | null | ReactNode;
  testId?: string;
}

const DetailsCardItemText = ({
  textToRender,
  hasCopyButton,
  copiedValue,
  customStyle,
  titleInlineAddition,
  testId
}: IDetailsCardItemTextProps) => {
  const { copyButtonCustomStyle } = useStyles();

  const displayText = () => {
    if (!textToRender) {
      return typeof textToRender === "number" ? textToRender : "-";
    }
    return textToRender;
  };

  return (
    <>
      <Typography
        variant="body2Medium"
        sx={customStyle}
        data-testid={testId ?? "details-card-item-text"}
      >
        {displayText()}
        {titleInlineAddition && (
          <span
            css={css({
              color: colors.textPlaceholder,
              marginLeft: "8px",
              fontWeight: 400
            })}
          >
            {titleInlineAddition}
          </span>
        )}
      </Typography>
      {hasCopyButton && copiedValue && (
        <CopyButton
          size="normal"
          copiedValue={copiedValue}
          buttonCustomStyle={copyButtonCustomStyle as {}}
        />
      )}
    </>
  );
};

export default DetailsCardItemText;
